export const ROOT = 'collapsible-list-component';

export const INSERT_COLLAPSIBLE_LIST_BUTTON = 'collapsible-list-insert-button';

export const NEW_PAIR_BUTTON = 'collapsible-list-new-pair-button';
export const COLLAPSIBLE_LIST_ITEM = 'collapsible-list-item';
export const COLLAPSIBLE_LIST_ITEM_TITLE = 'collapsible-list-item-title';
export const COLLAPSIBLE_LIST_ITEM_BODY = 'collapsible-list-item-body';
export const EXPAND_BUTTON = 'collapsible-list-expand-button';

export const SETTINGS_MODAL = 'collapsible-list-settings-modal';
export const SETTINGS_EXPAND_ONLY_ONE_TOGGLE = 'settings-expand-only-one-toggle';
export const SETTINGS_INITIAL_EXPANDED = 'settings-initial-expanded';
export const SETTINGS_INITIAL_EXPANDED_ALL = 'settings-initial-expanded-all';
export const SETTINGS_INITIAL_EXPANDED_FIRST = 'settings-initial-expanded-first';
export const SETTINGS_INITIAL_EXPANDED_NONE = 'settings-initial-expanded-none';
export const SETTINGS_DIRECTION = 'settings-direction';
export const SETTINGS_DIRECTION_LTR = 'settings-ltr-direction';
export const SETTINGS_DIRECTION_RTL = 'settings-rtl-direction';
export const SETTINGS_IS_QA_PAGE_TOGGLE = 'settings-is-qapage-data-toggle';
